<template>
  <div class="operate-platform">
    <table border="1">
      <tr class="header">
        <th class="left">平台类型</th>
        <th class="right">名称/地址</th>
      </tr>
      <tr class="operate-row" v-for="(item, index) in list" :key="index">
        <td class="left">{{ item.name }}</td>
        <td class="right">{{ item.url }}</td>
      </tr>
    </table>

    <div class="search-address">
      查询地址：<a
        href="http://icid.iachina.cn/?columnid_url=201509301401"
        target="_blank"
        >http://icid.iachina.cn/?columnid_url=201509301401
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        //   {
        //   name: '官方网站',
        //   url: 'https://www.luotuoguihua.com'
        // }, {
        //   name: '官方网站',
        //   url: 'https://m.luotuoguihua.com'
        // },
        {
          name: "公众号",
          url: "骆驼规划"
        },
        {
          name: "公众号",
          url: "骆驼说保"
        },
        {
          name: "公众号",
          url: "骆驼选保"
        },
        {
          name: "公众号",
          url: "骆驼荐保"
        },
        {
          name: "公众号",
          url: "骆驼讲保"
        },
        {
          name: "公众号",
          url: "骆驼保"
        },
        {
          name: "公众号",
          url: "骆驼放心保"
        },
        {
          name: "公众号",
          url: "骆驼配保"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.operate-platform {
  table {
    border-spacing: 0;
    margin: 0 auto;
    border: 1px solid #ebf0fc;
    border-color: #ebf0fc;
    border-collapse: collapse;
    box-shadow: 0px 16px 32px -4px rgba(137, 154, 230, 0.1);
  }

  .header {
    background: linear-gradient(
      180deg,
      rgba(249, 250, 255, 1) 0%,
      rgba(242, 246, 254, 1) 100%
    );
    .left {
      width: 181px;
      height: 68px;
      // background:rgba(253,180,40,1);
      border-radius: 8px 0px 0px 0px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(59, 59, 88, 1);
      line-height: 22px;
      text-align: center;
    }
    .right {
      width: 719px;
      height: 68px;
      text-align: center;
      // background:rgba(255,192,69,1);
      border-radius: 0px 8px 0px 0px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(59, 59, 88, 1);
      line-height: 22px;
    }
  }

  .operate-row {
    width: 116px;
    height: 50px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(105, 108, 141, 1);
    line-height: 14px;
    text-align: center;

    // .left {
    //   border: 1px solid #EBF0FC;
    // }

    // .right {
    //   border: 1px solid #EBF0FC;
    // }

    // &:nth-child(odd) {
    //   .left {
    //     background:rgba(234,234,234,1);
    //     opacity:0.7;
    //   }
    // }

    // &:nth-child(even) {
    //   .left {
    //     background:rgba(241,241,241,1);
    //     opacity:0.59;
    //   }
    // }

    // &:nth-child(odd) {
    //   .right {
    //     background:rgba(248,248,248,1);
    //     opacity:0.7;
    //   }
    // }

    // &:nth-child(even) {
    //   .right {
    //     background:rgba(253,253,253,1);
    //     opacity:0.59;
    //   }
    // }
  }

  .search-address {
    text-align: center;
    font-size: 12px;
    margin-top: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(105, 108, 141, 1);
    line-height: 9px;
    a {
      text-decoration: none;
      color: rgba(105, 108, 141, 1);
    }
  }
}
</style>
